import React, { Component } from 'react';

import actions from './../../store/Actions/index.js';
import { connect } from "react-redux";
import { withRouter } from 'react-router';

import Navbar from './../Navbar/navbar.jsx';
import './home.css';
import Navigation from './../Navigation/navigation.jsx';
import { Button } from 'react-bootstrap';

import { isLogin } from './../../utils/authentication.js';
import { Modal } from 'react-bootstrap';
import UpdateReportName from './../UpdateReportName/updateReportName.jsx';
import AddCost from './../AddCost/addCost.jsx';
import LinkToc from './../LinkToc/linkToc.jsx'
import  SharingModel from './../SharingModel/SharingModel.jsx'

import {
    BACKEND_URL
} from '../../config.js';
import axios from 'axios';


class Home extends Component{
    state = {
        list:null,
        show:false,
        reportId:"",
        isSuperAdmin:false,
        currentCost: null,
        im_id: null,
        bis_id: null,
        sharingIds: []
    }
    async componentDidMount(){
        if(!isLogin()){
            this.props.history.push({
                pathname:"/login"
            });
        }
        await this.props.getList();
        this.setState({list:this.props.list.list});
    }

    onSubmit=(id) => {
        this.props.history.push({
            pathname:"/detail",
            state:{
                _id:id            
            }
        })
    };

    onUpdateClick = (reportId) => {
        this.setState({show:true}); 
        this.setState({reportId:reportId});
    }

    onDeleteClick = (reportId) => {
        if(window.confirm('Delete this report permanent?')){
           this.props.onDeleteClick({reportId:reportId});
           alert("Report Deleted! Please Refresh This Page!")
           // window.location.reload(true);
        }
    }

    onArchiveClick = (reportId) => {
        if(window.confirm('Archive this report?')){
           this.props.onArchiveClick({reportId:reportId});
           alert("Report Archived! Please Refresh This Page!")
           // window.location.reload(true);
        }
    }

    onTOC = (reportId, reportName) => {
        console.log(reportId, reportName, "111")
        this.setState({showTOC:true, im_id: reportId, im_name: reportName}); 
    }

    onSharing = (reportId, reportName, sharingIds) => {
        console.log(reportId, reportName, "111")
        this.setState({clientSharing:true, im_id: reportId, im_name: reportName, sharingIds: sharingIds}); 
    }

    onHideSharing = () => {
        this.setState({ clientSharing:false });
    }
    

    onUpdateClose = () => {
        this.setState({show:false});
    }

    componentWillMount = () => {
        if(localStorage.getItem("userType") === "superAdmin"){
            this.setState({isSuperAdmin:true});
        }
    }
    onAddCost=async(reportId, cost) => {
        this.setState({addCost:true, currentCost: cost});
        this.setState({reportId:reportId});
    }

    onHide = async() => {
        this.setState({addCost:false});
        this.componentDidMount()
    }

    onHideTOC = () => {
        this.setState({ showTOC: false});
    }

    handleTOC = (bis_id)=> {
        axios.post(
            BACKEND_URL + "/v1/admin/report/link_toc",{
                reportId: this.state.im_id,
                bis_id: bis_id
            },{
                headers:{
                    token: localStorage.getItem("token")
                }
            }
        ).then((res) => {
            this.setState({showTOC: false});
            this.componentDidMount()
        }).catch((err) => {
            alert("Something went wrong!, Contact Mr Tariq")
        })
    }

    handleSharing = (ids)=> {
        let finalIds = ids.map((o)=> o.companyId)
        axios.post(
            BACKEND_URL + "/v1/admin/report/sharingManage",{
                reportId: this.state.im_id,
                sharingIds: finalIds
            },{
                headers:{
                    token: localStorage.getItem("token")
                }
            }
        ).then((res) => {
            this.setState({clientSharing: false});
            this.componentDidMount()
        }).catch((err) => {
            alert("Something went wrong!, Contact Mr Tariq")
        })
    } 

    render(){
        return(
            <div> 
                <div className="col-md-12 topbar">
                    <Navbar />
                    <Navigation />
                </div>
                <div className="col-md-12 pageBg">
                    <h1>Total {this.state && this.state.list && this.state.list.length} Reports!</h1>
                    {this.state && this.state.list && this.state.list.map((listObj, index) => (
                        <div className="card" key={listObj._id}>

                            <div className="card-body">
                                <h5 className="card-title">{listObj.reportName} - {listObj.cost ? `$${listObj.cost}` : <span style={{color: 'red'}}>Add cost</span>}  {!listObj.bis_id && <span style={{color: 'red'}}> - Link TOC</span>}</h5>
                                <div className="row">
                                    <div className="col-md-1">
                                        <Button variant="primary" type="submit" onClick={this.onSubmit.bind(this,listObj._id)}>
                                            Detail
                                        </Button>
                                    </div>
                                    {this.state.isSuperAdmin && <div className="col-md-1">
                                        <Button variant="primary" type="submit" onClick={this.onUpdateClick.bind(this,listObj._id)}>
                                            Update
                                        </Button>
                                    </div>
                                    }

                                    {this.state.isSuperAdmin && <div className="col-md-1">
                                        <Button varient="primary" type="submit" onClick={this.onAddCost.bind(this,listObj._id, listObj.cost)}>
                                            Add Cost
                                        </Button>
                                    </div>}

                                    { this.state.isSuperAdmin && 
                                        <div className="col-md-1">
                                            <Button variant="primary" type="submit" onClick={this.onTOC.bind(this,listObj._id, listObj.reportName)}>
                                                Link TOC 
                                            </Button>
                                        </div>
                                    }

                                    {this.state.isSuperAdmin && <div className="col-md-1">
                                        <Button variant="primary" type="submit" onClick={this.onDeleteClick.bind(this,listObj._id)}>
                                            Delete Permanent
                                        </Button>
                                    </div>
                                    }

                                    {!listObj.isActive && <span style={{color: 'green'}}> This report is removed from search but user can still access its files in My Library </span>}

                                    { this.state.isSuperAdmin && listObj.isActive && <div className="col-md-1">
                                        <Button variant="primary" type="submit" onClick={this.onArchiveClick.bind(this,listObj._id)}>
                                            Archive 
                                        </Button>
                                    </div>
                                    }

                                    { this.state.isSuperAdmin && listObj.isActive && 
                                        <div className="col-md-1">
                                            <Button variant="primary" type="submit" onClick={this.onSharing.bind(this,listObj._id, listObj.reportName, listObj.sharing)}>
                                                Client Sharing 
                                            </Button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <Modal size="lg" show={this.state.show} onHide={this.onUpdateClose}>
                    <Modal.Header closeButton>
                        <div className="row col-md-12">
                            <Modal.Title className="col-md-6 heading-details">Update report Name</Modal.Title>
                        </div>   
                    </Modal.Header>
                    <Modal.Body className="modal-body">
                        <UpdateReportName reportId={this.state.reportId} />
                    </Modal.Body>
                </Modal>
                <Modal size="lg" show={this.state.addCost} onHide={this.onHide}>
                    <Modal.Header closeButton>
                        <div className="row col-md-12">
                            <Modal.Title className="col-md-6 heading-details">Add Cost</Modal.Title>
                        </div>   
                    </Modal.Header>
                    <Modal.Body className="modal-body">
                        <AddCost reportId={this.state.reportId} cost1={this.state.currentCost} onSave={this.onHide} />
                    </Modal.Body>
                </Modal>

                <Modal size="lg" show={this.state.showTOC} onHide={this.onHideTOC}>
                    <Modal.Header closeButton>
                        <div className="row col-md-12">
                            <div>Link TOC: <b>{this.state.im_name}</b></div>
                        </div>   
                    </Modal.Header>
                    <Modal.Body className="modal-body">
                        <LinkToc onSubmit={this.handleTOC} />
                    </Modal.Body>
                </Modal>

                <Modal size="lg" show={this.state.clientSharing} onHide={this.onHideSharing}>
                    <Modal.Header closeButton>
                        <div className="row col-md-12">
                            <div>Share Report: <b>{this.state.im_name}</b></div>
                        </div>   
                    </Modal.Header>
                    <Modal.Body className="modal-body">
                        <SharingModel onSubmit={this.handleSharing} sharingIds={this.state.sharingIds} />
                    </Modal.Body>
                </Modal>

            </div>
        )
    }
} 

const mapStateToProps = state => ({
    list:state.list
});

const mapDispatchToProps = dispatch => ({
    getList:(v) => dispatch(actions.getList(v)),
    onDeleteClick:(v) => dispatch(actions.onDeleteClick(v)),
    onArchiveClick:(v) => dispatch(actions.onArchiveClick(v))
});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(Home));


// WEBPACK FOOTER //
// ./src/components/Home/home.jsx